import React, {useState, useEffect} from "react";
import {AdfoxBlock} from "./AdfoxBlock";

export const BottomAd = ({isFull, isDesktop, options}) => {
    const [showAd, setShowAd] = useState(false);
    const [shown, setShown] = useState(false);

    const handleScroll = () => {
        if (window.pageYOffset > 200 && !shown) {
            setShowAd(true);
        }
    };

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [shown]);

    if (!showAd) {
        return null;
    }

    return (
        <div className="bottom-ad">
            <div className="bottom-ad__wrap">
                <div
                    className="bottom-ad__closer"
                    onClick={() => {
                        setShown(true);
                        setShowAd(false);
                    }}
                ></div>
                <AdfoxBlock isFull={isFull} isDesktop={isDesktop} options={options}/>
            </div>
        </div>
    );
};
